export interface RegionData {
  name: string
  currency: string
  price: string
  paymentMethods: {
    type: string
    details?: string
    accountNumber?: string
    accountName?: string
    email?: string
    paymentLink?: string
  }[]
}
export const regions: RegionData[] = [
  {
    name: 'Nigeria',
    currency: '₦',
    price: '10,250',
    paymentMethods: [
      {
        type: 'Bank Transfer',
        details: 'GTBank',
        accountNumber: '9007999707',
        accountName: 'PAYMENT CHECKOUT',
      },
      {
        type: 'Bank Transfer',
        details: 'Wema Bank',
        accountNumber: '8180809655',
        accountName: 'PAYMENT CHECKOUT',
      },
      {
        type: 'Bank Transfer',
        details: '9Payment Service Bank',
        accountNumber: '6159956825',
        accountName: 'PAYMENT CHECKOUT',
      },
      {
        type: 'Bank Transfer',
        details: 'StanbicIBTC Bank',
        accountNumber: '5017042289',
        accountName: 'PAYMENT CHECKOUT',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Ghana',
    currency: 'GHC 100',
    price: '',
    paymentMethods: [
      {
        type: 'MTN MOMO',
        accountNumber: '0598544757',
        accountName: 'Chinedus Arbitrage Ventures',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Kenya',
    currency: 'KES 1,000',
    price: '',
    paymentMethods: [
      {
        type: 'MPESA',
        details: 'Pay Now',
        paymentLink: 'https://flutterwave.com/pay/lnblmtyantun',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Uganda',
    currency: 'UGX 30,000',
    price: '',
    paymentMethods: [
      {
        type: 'Mobile Money',
        details: 'Pay Now',
        paymentLink: 'https://flutterwave.com/pay/zeldpzjtwutt',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Cameroon',
    currency: 'CFA 10,000',
    price: '',
    paymentMethods: [
      {
        type: 'MTN MOMO',
        accountNumber: '652773435',
        accountName: 'Atem Rose Ayuk',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Rwanda',
    currency: 'RWF 12,000',
    price: '',
    paymentMethods: [
      {
        type: 'Mobile Money',
        details: 'Pay Now',
        paymentLink: 'https://flutterwave.com/pay/o0ruftgbvdqj',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Zambia',
    currency: 'ZMW 200',
    price: '',
    paymentMethods: [
      {
        type: 'Mobile Money',
        details: 'Pay Now',
        paymentLink: 'https://flutterwave.com/pay/1wkvf7hycx5t',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Sierra Leone',
    currency: 'SLE 400',
    price: '',
    paymentMethods: [
      {
        type: 'Orange Money Agent',
        details: 'Contact Agent',
        paymentLink: 'https://t.me/m/5Z5_houXYWE0',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Crypto',
      },
    ],
  },
  {
    name: 'Others',
    currency: '$',
    price: '12',
    paymentMethods: [
      {
        type: 'Crypto',
      },
      {
        type: 'Skrill',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
      {
        type: 'Neteller',
        details: '$12',
        email: 'reachsamex@gmail.com',
      },
    ],
  },
]
export const cryptoOptions = {
  usdt: {
    networks: [
      {
        name: 'TRC20',
        address: 'TVZFyaEgSdFyzrRBVwLfoxWjix1hKRckBg',
      },
      {
        name: 'BEP20',
        address: '0x0c09b0e00f79ca8710d57d30e0d2b4b4a093fb10',
      },
      {
        name: 'ERC20',
        address: '0x0c09b0e00f79ca8710d57d30e0d2b4b4a093fb10',
      },
    ],
  },
  btc: {
    address: '1GG8ieYbjdWUBeSisU5231i5XuXPr5zAxS',
  },
  eth: {
    address: '0x0c09b0e00f79ca8710d57d30e0d2b4b4a093fb10',
  },
}
export const getRegionData = (regionName: string): RegionData => {
  return regions.find((region) => region.name === regionName) || regions[0]
}
